// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3U5c5","title":"ezy_k","table":"_3WwvR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewsBlock/SimpleTable.scss
 ** module id = 102
 ** module chunks = 0
 **/